export class User {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'User'
  }
}

export class Federation {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'Federation'
  }
}

export class Core {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'Core'
  }
}

export class Ej {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'Ej'
  }
}

export class Contract {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'Contract'
  }
}

export class ConnectionProduct {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'ConnectionProduct'
  }
}

export class ConnectionProductCategory {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'ConnectionProductCategory'
  }
}

export class CommunitiesPost {
  constructor(attrs) {
    Object.assign(this, attrs)
  }

  static get modelName() {
    return 'CommunitiesPost'
  }
}
